export default __webpack_public_path__ + "static/ThinkstockPhotos-545251390_article-aa563db57ad41d9e04254fa94d4da912.jpg";